import { ToastrService } from 'ngx-toastr';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthenticationService } from '../authentication/authentication.service';
import { InfoTokenService } from '../infoUser/info-user.service';
import { IDataToken, IUser } from '../../interfaces/toolbar/toolbar.interface';

@Injectable({
  providedIn: 'root',
})
export class MangoInterceptorService implements HttpInterceptor {
  CODES = {
    CODES_REFRESH: {
      CODE: 401,
      MESSAGE: 'Token expired',
    },
    CODES_INVALID: {
      CODE: 401,
      MESSAGE: 'Invalid token',
    },
  };

  constructor(
    private auth: AuthenticationService,
    private toast: ToastrService,
    private infoTokensService: InfoTokenService
  ) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let req = request;
    if (
      !req.url.includes('X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-') &&
      !req.url.includes('refresh')
    ) {
      req = request.clone({
        headers: request.headers
          .set('Content-Type', 'application/json')
          .set('Authorization', `Bearer ${this.infoTokensService.getToken()}`),
      });
    }
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === this.CODES.CODES_REFRESH.CODE) {
            switch (error.error.message) {
              // If refresh token
              case this.CODES.CODES_REFRESH.MESSAGE:
                const currentUser: IDataToken =
                  this.infoTokensService.getDataToken();
                const refreshToken = this.infoTokensService.getResfreshToken();

                if (!refreshToken) {
                  this.auth.logout();
                  return throwError(error);
                }

                return this.auth
                  .refreshToken(
                    `${currentUser.username}:users`,
                    `${currentUser.username}:current`,
                    refreshToken
                  )
                  .pipe(
                    switchMap(
                      (response: {
                        jwtToken: string;
                        refreshToken: string;
                      }) => {
                        // Update token and refresh token in cookies
                        this.infoTokensService.setToken(
                          response.jwtToken,
                          response.refreshToken
                        );
                        // Retry the original request with the new token
                        const retryRequest = request.clone({
                          headers: request.headers
                            .set('Content-Type', 'application/json')
                            .set(
                              'Authorization',
                              `Bearer ${response.jwtToken}`
                            ),
                        });
                        return next.handle(retryRequest);
                      }
                    ),
                    catchError((refreshError) => {
                      // If refresh token fails, logout
                      this.auth.logout();
                      return throwError(refreshError);
                    })
                  );

              // If Invalid token
              case this.CODES.CODES_INVALID.MESSAGE:
                this.toast.error(
                  'Invalid token',
                  error.error.errorMessage || this.CODES.CODES_INVALID.MESSAGE
                );
                this.auth.logout();
                return throwError(error);
            }
          }
        }
        // Return error
        return throwError(error);
      })
    );
  }
}
export const AuthInterceptorProvider = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: MangoInterceptorService,
    multi: true,
  },
];
